(function (Translator) {
    // ro
    Translator.add("address", "Adres\u0103:", "PayseraMapBundle", "ro");
    Translator.add("friday", "Vineri", "PayseraMapBundle", "ro");
    Translator.add("monday", "Luni", "PayseraMapBundle", "ro");
    Translator.add("no_results", "Nu au fost g\u0103site rezultate", "PayseraMapBundle", "ro");
    Translator.add("saturday", "S\u00e2mb\u0103t\u0103", "PayseraMapBundle", "ro");
    Translator.add("search_placeholder", "Introduce\u021bi fragmentul", "PayseraMapBundle", "ro");
    Translator.add("service.cash_in", "Depunere numerar", "PayseraMapBundle", "ro");
    Translator.add("service.cash_out", "Retragere numerar", "PayseraMapBundle", "ro");
    Translator.add("service.identification", "Identificare ", "PayseraMapBundle", "ro");
    Translator.add("service.pay", "Pl\u0103\u021bi", "PayseraMapBundle", "ro");
    Translator.add("services", "Servicii:", "PayseraMapBundle", "ro");
    Translator.add("sunday", "Duminic\u0103", "PayseraMapBundle", "ro");
    Translator.add("thursday", "Joi", "PayseraMapBundle", "ro");
    Translator.add("tuesday", "Mar\u0163i", "PayseraMapBundle", "ro");
    Translator.add("wednesday", "Miercuri", "PayseraMapBundle", "ro");
    Translator.add("working_hours", "Ore de lucru:", "PayseraMapBundle", "ro");
})(Translator);
